import { alertConstants as baseConstants } from '../alert.constants'

const constants = {
  LOADING_INDICATOR_START: 'LOADING_INDICATOR_START',
  LOADING_INDICATOR_SUCCESS: 'LOADING_INDICATOR_SUCCESS',
  LOADING_INDICATOR_PROGRESS: 'LOADING_INDICATOR_PROGRESS',
};

export const alertConstants = Object.assign(constants, baseConstants)
